import { Image, ImageProps } from '@chakra-ui/react';
import React from 'react';
import config from '../constants/config';

const Logo: React.FC<ImageProps> = props => (
  <Image src={`${config.urls.publicUrl}/logo.svg`} {...props} />
);

export default Logo;
